import React from 'react';
import { Link } from 'react-router-dom';
import { FaStar, FaHeart, FaShoppingCart, FaHome } from 'react-icons/fa';
import PostCard from '../components/PostCard';
import { Helmet } from "react-helmet";

const posts = [
  {
    id: 1,
    title: 'A fenntartható kert alapjai: Talaj-előkészítés lépésről lépésre',
    excerpt: 'Ismerje meg a természetes talajjavítás titkait, a komposztálást és a talajélet fontosságát a fenntartható kert kialakításában.',
    category: 'Talaj és komposzt',
    image: '/images/1.jpg',
    author: 'Kertész Anna',
    date: '2025. január 10.',
    rating: '4.9'
  },
  {
    id: 2,
    title: 'Szezonális növényápolási kalauz 2025-re',
    excerpt: 'Komplett idővonal a kerti teendőkről egész évre: tavaszi ültetéstől a téli védelemig.',
    category: 'Szezonális tippek',
    image: '/images/2.jpg',
    author: 'Kertész Anna',
    date: '2025. január 8.',
    rating: '4.8'
  },
  {
    id: 3,
    title: 'Évelő virágok: A legszebb választások kertjébe',
    excerpt: 'Fedezze fel a legszebb évelő növényeket, amelyek évekig díszítik kertjét minimális karbantartás mellett.',
    category: 'Virágok',
    image: '/images/3.jpg',
    author: 'Molnár Péter',
    date: '2025. január 5.',
    rating: '4.7'
  },
  {
    id: 4,
    title: 'Öntözés okosan: Víz-megtakarítási technikák kertjében',
    excerpt: 'Tudja meg, hogyan csökkentheti akár 50 százalékkal a vízfelhasználást kertje öntözésében modern és hagyományos módszerekkel.',
    category: 'Öntözés',
    image: '/images/4.jpg',
    author: 'Kovács Éva',
    date: '2025. január 3.',
    rating: '4.9'
  },
  {
    id: 5,
    title: 'Városi kertészet: Zöld oázis létrehozása erkélyen',
    excerpt: 'Gyakorlati útmutató az erkélykertészethez: konténerek, függőleges kertek és mini veteményesek városi környezetben.',
    category: 'Városi kert',
    image: '/images/5.jpg',
    author: 'Nagy István',
    date: '2025. január 1.',
    rating: '4.6'
  }
];

function Home() {
  return (
    <>
      <Helmet>
        <title>Bromeli Műhely - Kertészeti Tanácsadó Blog</title>
        <meta name="description" content="Bromeli kertészeti blog - szakértői tanácsok, növényápolási tippek, fenntartható kertészeti megoldások és szezonális kerti kalauz." />
      </Helmet>

      <div>
      <section className="hero">
        <div className="hero-content">
          <h1>Bromeli Kertészeti Műhely</h1>
          <p>Fedezze fel a kertészkedés örömét a Bromeli szakértői útmutatásával. Fenntartható megoldások, gyakorlati tippek és inspiráló tartalmak minden kertbarát számára.</p>
          <div className="hero-stats">
            <div className="hero-stat">
              <h3>5000+</h3>
              <p>Elégedett olvasó</p>
            </div>
            <div className="hero-stat">
              <h3>8 év</h3>
              <p>Szakmai tapasztalat</p>
            </div>
            <div className="hero-stat">
              <h3>350+</h3>
              <p>Bejegyzés</p>
            </div>
          </div>
        </div>
      </section>

      <section className="container">
        <div className="features">
          <div className="feature-card">
            <div className="feature-icon"><FaStar /></div>
            <h3>Szakértői tudás</h3>
            <p>Kertészeti szakemberek írják tartalmainkat, több évtizedes gyakorlati tapasztalattal.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FaHeart /></div>
            <h3>Szenvedély a természetért</h3>
            <p>Minden cikkünk a környezettudatosságot és a természet szeretetét helyezi a középpontba.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FaShoppingCart /></div>
            <h3>Gyakorlati megoldások</h3>
            <p>Kipróbált technikák és termékajánlások, amelyek azonnal használhatók kertjében.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon"><FaHome /></div>
            <h3>Közösség</h3>
            <p>Csatlakozzon hasonló gondolkodású kertészek közösségéhez, ossza meg tapasztalatait.</p>
          </div>
        </div>

        <div className="about-section">
          <h2>Üdvözöljük a Bromeli Kertészeti Blogban</h2>
          <p>
            A Bromeli Kertészeti Blog a kertészkedés szenvedélyeskedőinek nyújt megbízható és naprakész információt. 
            Célunk, hogy segítsük Önt egy gyönyörű, fenntartható és produktív kert kialakításában, függetlenül attól, 
            hogy kezdő vagy tapasztalt kertész. Minden cikkünket szakértő kollégáink írják, akik nemcsak elméleti 
            tudással, hanem gazdag gyakorlati tapasztalattal is rendelkeznek.
          </p>
          <p>
            Blogunk tematikája öleli fel a talaj-előkészítést, a növényápolást, a kártevőirtást, a vízgazdálkodást, 
            valamint a városi kertészet legújabb trendjeit. Minden bejegyzésünket alapos kutatás előzte meg, 
            és a legfrissebb agrártudományi ismeretekre épülnek. Tartalmaink közérthetőek és könnyen alkalmazhatók 
            a mindennapi kerti munkában.
          </p>
          <p>
            Hiszünk abban, hogy a kertészkedés nemcsak hobbi, hanem életforma. Ezért is törekszünk arra, 
            hogy fenntartható megoldásokat népszerűsítsünk, csökkentve környezeti lábnyomunkat. A Bromeli 
            csapat elkötelezett amellett, hogy a kertészkedés mindenki számára elérhető és élvezetes legyen.
          </p>
          <h3>Miért olvassa a Bromeli blogot?</h3>
          <ul>
            <li><strong>Szakértői tartalom:</strong> Minden cikkünket agrármérnökök és kertészmérnökök írják.</li>
            <li><strong>Friss ismeretek:</strong> Naprakész trendek és innovatív kertészeti technikák.</li>
            <li><strong>Közérthető stílus:</strong> Bonyolult témákat egyszerűen magyarázunk el.</li>
            <li><strong>Valós tapasztalat:</strong> Teszteltük a technikákat, mielőtt publikálnánk.</li>
          </ul>
        </div>
      </section>

      <section className="container posts-grid">
        <div className="section-header">
          <h2>Legújabb bejegyzéseink</h2>
          <p>Fedezze fel legfrissebb kertészeti írásainkat, amelyek segítenek álmai kertjének megvalósításában.</p>
        </div>
        <div className="features" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))' }}>
          {posts.map(post => (
            <PostCard key={post.id} post={post} />
          ))}
        </div>
      </section>

      <section className="container" style={{ textAlign: 'center', paddingBottom: '50px' }}>
        <div className="about-section" style={{ background: 'linear-gradient(135deg, rgba(85,107,47,0.9), rgba(138,154,91,0.9))', color: 'white' }}>
          <h2 style={{ color: 'white' }}>Csatlakozzon kertész közösségünkhöz</h2>
          <p style={{ color: 'white', fontSize: '1.1rem', marginBottom: '30px' }}>
            Iratkozzon fel hírlevelünkre és kapja meg havi kertészeti tippjeinket, exkluzív tartalmainkat és korai hozzáférést eseményeinkhez.
          </p>
          <Link to="/contact" className="btn btn-accent" style={{ fontSize: '1.1rem', padding: '15px 40px' }}>
            Kapcsolatfelvétel
          </Link>
        </div>
      </section>
    </div>
  
    </>);
}

export default Home;